import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

const AppUrlListener: React.FC<any> = () => {
  let history = useHistory();
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    /*App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      // Example url: https://beerswift.app/tabs/tab2
      // slug = /tabs/tab2
      const slug = event.url.split(".app").pop();
      if (slug) {
        console.log("DEBUG", slug);

        history.push(slug);
      }
      // If no match, do nothing - let regular routing
      // logic take over
    });*/
  }, []);

  return null;
};

export default AppUrlListener;
